export const ACC_OAUTH_POPUP_MESSAGE = "primepoint:acc-oauth-callback";

/** `window.open`/`window.name` handshake name for the ACC OAuth popup --
 *  AutodeskConstructionCloud.tsx (the popup's own landing page) checks
 *  `window.name` against this to know it's running inside the staff wizard's
 *  popup rather than the ordinary embedded-tenant OAuth flow. */
export const ACC_OAUTH_POPUP_NAME = "primepoint-acc-oauth";

/** The popup a person's own document-provider sign-in opens (`useProviderConnect`, Autodesk or
 *  Procore). It lands on the same relay and posts the same message. */
export const PROVIDER_OAUTH_POPUP_NAME = "primepoint-provider-oauth";

/** Whether this window is one of the named OAuth popups the integrations relay answers for. */
export function isOAuthPopupWindow(): boolean {
    return window.name === ACC_OAUTH_POPUP_NAME || window.name === PROVIDER_OAUTH_POPUP_NAME;
}

export interface AccOAuthPopupMessage {
    type: typeof ACC_OAUTH_POPUP_MESSAGE;
    code: string | null;
    state: string | null;
    error: string | null;
}

/** A nullable-string field posted from the popup -- present and either a
 *  string or `null`, never absent (the popup always includes all three of
 *  code/state/error, even when unset). */
function isNullableString(value: unknown): value is string | null {
    return value === null || typeof value === "string";
}

export function isAccOAuthPopupMessage(value: unknown): value is AccOAuthPopupMessage {
    if (!value || typeof value !== "object") return false;
    const candidate = value as Record<string, unknown>;
    return (
        candidate.type === ACC_OAUTH_POPUP_MESSAGE &&
        isNullableString(candidate.code) &&
        isNullableString(candidate.state) &&
        isNullableString(candidate.error)
    );
}
